import {
    DRAWER_OPENED, DRAWER_CLOSED, SEARCH, MAP_STYLE_CHANGED, OX_MODE_CHANGED, LANG_CHANGED,
    OX_LIST_STYLE_CHANGED
} from "./types";
import {MapStyle} from "../../components/openexplore/Mapbox/Mapbox";
import {DisplayMode, ListDisplayMode} from '../../components/openexplore/OpenExplore/OpenExplore'
import {Cookies} from 'react-cookie';
import LangService from "../../services/lang";

const cookies = new Cookies();

export const INITIAL_STATE = {
    drawerOpened: true,
    leftPadding: 236,
    search: '',
    mapStyle: cookies.get('map-style') || MapStyle.STREETS,
    oxMode: cookies.get('ox-mode') || DisplayMode.MODE_MAP,
    oxListMode: parseInt(cookies.get('ox-list') || ListDisplayMode.POINTS, 10),
    currentLang: cookies.get('lang') || LangService.defaultLang
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case DRAWER_CLOSED:
            return {
                ...state,
                drawerOpened: false,
                leftPadding: 0
            };
        case DRAWER_OPENED:
            return {
                ...state,
                leftPadding: INITIAL_STATE.leftPadding,
                drawerOpened: true,
            };
        case SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case MAP_STYLE_CHANGED:
            cookies.set('map-style', action.payload, {path: '/'});
            return {
                ...state,
                mapStyle: action.payload
            };
        case OX_MODE_CHANGED:
            cookies.set('ox-mode', action.payload, {path: '/'});
            return {
                ...state,
                oxMode: action.payload
            };
        case OX_LIST_STYLE_CHANGED:
            cookies.set('ox-list', action.payload, {path: '/'});
            return {
                ...state,
                oxListMode: action.payload
            };
        case LANG_CHANGED:
            cookies.set('lang', action.payload, {path: '/'});
            return {
                ...state,
                currentLang: action.payload
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/ui/reducers.js